export default __webpack_public_path__ + "static/media/101_bananice.d5a78ad0.png";